<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Concorrentes">
      <crud-base
        :url="url"
        :columns="columns"
        :onDelete="() => {}"
        :onUpdate="() => {}"
        :onStore="() => {}"
        :enableSearch="true"
        :checkAlerts="true"
        :formInputs="formInputs"
        primaryKey="id"
      />
    </CTab>
  </CTabs>
</template>

<script>
import CrudBase from "../../components/crud/CrudBase";
import { schemaTextField, schemaBooleanSelect } from "@/helpers/form";
import { yesNoRepresentation } from "@/helpers/transformers";

export default {
  name: "Concorrente",
  components: { CrudBase },
  data() {
    return {
      url: "/admin/concorrentes",
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "RAZÃO SOCIAL", field: "razaosocial", sortable: false },
        { label: "FANTASIA", field: "fantasia", sortable: false },
        { label: "CNPJ", field: "cnpj", sortable: false },
        { label: "CIDADE", field: "cidade", sortable: false },
        { label: "UF", field: "uf", sortable: false },
        {
          label: "ATIVO",
          field: "ativo",
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.ativo),
        },
      ],
      formInputs: {
        id: schemaTextField("Cód.", true, 2),
        razaosocial: schemaTextField("Razão Social", true, 5),
        fantasia: schemaTextField("Fantasia", false, 5),
        cnpj: schemaTextField("CNPJ", false, 3),
        inscricaoestadual: schemaTextField("Inscrição Estadual", false, 3),
        telefone: schemaTextField("Telefone", false, 3),
        endereco: schemaTextField("Endereço", false, 5),
        numero: schemaTextField("Número", false, 2),
        complemento: schemaTextField("Complemento", false, 3),
        bairro: schemaTextField("Bairro", false, 3),
        cidade: schemaTextField("Cidade", false, 3),
        uf: schemaTextField("UF", false, 1),
        cep: schemaTextField("CEP", false, 2),
        ativo: schemaBooleanSelect("Ativo", true, 2, 1, 1),
      },
    };
  },
};
</script>
